import React from 'react';
import Button from '../../atoms/Button/Button';
import Icon from '../../atoms/Icon/Icon';
import ProgressBar from '../../atoms/ProgressBar/ProgressBar';
import useUploadFileItem from './useUploadFileItem';

export type UploadFileItemProps = Readonly<{
  file: Pick<File, 'name' | 'size'>;
  onRemove: () => void;
  isUploading?: boolean;
  progress?: number;
  isDisabled?: boolean;
}>;

function UploadFileItem({ file, onRemove, isUploading = false, progress = 0, isDisabled = false }: UploadFileItemProps): React.JSX.Element {
  const { deleteFileLabel, fileIcon, fileSize, uploadingLabel } = useUploadFileItem({ file });

  return (
    <li className="ui-upload-file-item">
      <div className="ui-upload-file-item__icon-container">
        <Icon color="primary" name={fileIcon} size="md" />
      </div>
      <div className="ui-upload-file-item__info">
        <span className="ui-upload-file-item__name">{file.name}</span>
        {isUploading ? (
          <ProgressBar hasPercentageLabel={false} isLabelHidden label={uploadingLabel} progress={progress} size="medium" />
        ) : (
          <span className="ui-upload-file-item__size">{fileSize}</span>
        )}
      </div>
      {!isUploading && (
        <Button
          ariaLabel={deleteFileLabel}
          className="ui-upload-file-item__delete"
          iconSize="md"
          isDisabled={isDisabled}
          isIconOnly
          leftIcon="trash"
          onClick={onRemove}
          size="sm"
          variant="secondary-ghost"
        />
      )}
    </li>
  );
}

export default UploadFileItem;
